/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import axios from 'axios';
// import baseUrl from '../endpoints';
import {apiUrl, subscriptionKey} from '../endpoints.js';

const endpoint = apiUrl;
const subsKey = subscriptionKey;

    export function listLegalDocumentsCall(
        documentTypeOwner, 
        status, 
        identityId, 
        roleId, 
        orderBy, 
        sortDirection, 
        rfc, 
        serviceId, 
        authorization, 
        transportKey,
        licenseId,
        platformDocumentTypeId
    ) {

        let headers = {
            'Content-Type': 'application/json', 
            'Authorization': authorization, 
            'identityId': identityId,
            'Ocp-Apim-Subscription-Key': subsKey,
            'transportKey': transportKey,
            'licenseId': licenseId,
            'internal': 'true',
        };

        if (rfc)
            headers['rfc'] = rfc;
        if (serviceId)
            headers['serviceId'] = serviceId;

        return axios({
            method: 'get',
            url: endpoint + 'api/v1/legalDocuments?version=1&' + documentTypeOwner + status + roleId + platformDocumentTypeId + orderBy + sortDirection,
            headers: headers
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
    }

    export function sendDocumentSignedCall(data, headers) {
        headers['Ocp-Apim-Subscription-Key'] = subsKey;
        return axios({
            method: 'post',
            url: endpoint + 'api/v1/legalDocuments/sign-document',
            headers: headers,
            data: data
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response.data;
        });
    }
    